/**
 * PageNavigation
 */

import Config from '../Config';
import Util from '../Util';
import Template from './Template';
import ParamInfo from './ParamInfo';

class PageNavigation {

	private paramInfo: any;

	constructor( paramInfo = new ParamInfo() ) {
		this.paramInfo = paramInfo;
	}

	public setUI( data: any ) {
		const _page = data || ``;
		const _prev = _page.previousPaginationPage;
		const _next = _page.nextPaginationPage;
		const _end = _page.endPage;
		const _pageLast = _page.lastPage;
		const _cur = _page.currentPage;
		const _param = this.paramInfo.getParamIgnore( 'page' );

		const tmp: any = Util.Tmpl.iterate({
			data: _page.pageList,
			template: ( _v: any ) => `
				${ ( parseInt( _v, 10 ) === parseInt( _cur, 10 ) ) ?
					`<li class="current">${_v}</li>` :
					`<li><a href="${Config.listPage}?page=${_v}${_param}" data-paging="${_v}">${_v}</a></li>`
				}`,
		});

		// @TODO should make L10N - prev, next
		return Util.Tmpl.render({
			data: {page: tmp, prev: _prev, next: _next},
			template: ( _v: any ) => `
				<div class="pagination-container">
					<ul class="pagination-list">
						${ ( _v.prev ) ?
							`<li class="prev"><a href="${Config.listPage}?page=${_v.prev}${_param}" data-paging="${_v.prev}"></a></li>`
							: `` }
						${_v.page}
						${ ( ( _end > _cur ) && ( _end > _pageLast ) ) ?
							`<li class="next"><a href="${Config.listPage}?page=${_v.next}${_param}" data-paging="${_v.next}"></a></li>`
							: `` }
					</ul>
				</div>`,
		});

		// return Template.pageNavigation( data );
	}
}

export default PageNavigation;
